import {SellingUnitDto, SellingUnitsDto} from "../../dtos";
import {Action} from "../actions/sellingUnitsActions";
import {ActionType} from "../actionTypes";


export class SellingUnitsInitialState implements SellingUnitsDto {
    sellingUnits = [];
    sellingUnitsForFlyer = []
}

const initialState = new SellingUnitsInitialState();

const reducer = (state: SellingUnitsDto = initialState, action: Action) => {

    switch(action.type)
    {
        //
        case ActionType.SET_SALE_UNITS_FOR_ALL_FLYERS:
            return {
                ...state,
                sellingUnits: action.payload.map((sellingUnit: SellingUnitDto) => {
                    return {
                        ...sellingUnit,
                        value: sellingUnit.languageCaption,
                        label: sellingUnit.languageCaption
                    }
                })
            };
        case ActionType.SET_SALE_UNITS_FOR_FLYER:
            return {
                ...state,
                sellingUnitsForFlyer: action.payload.map((sellingUnit: SellingUnitDto) => {
                    return {
                        ...sellingUnit,
                        value: sellingUnit.languageCaption,
                        label: sellingUnit.languageCaption
                    }
                })
            };
        default:
            return state;
    }
}

export default reducer;
